import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AsyncDropdown } from '@ami/react/core';
import { DealerBranch } from '../dealer-branches/dealerBranch';
import { DealerBranchFilter } from '../dealer-branches/dealerBranchFilter';

export class DealerBranchesAsyncDropdown extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    dealerGroupId: PropTypes.string,
    selected: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  };
  async fetchItems(name, dealerGroupId) {
    return (
      await DealerBranch.search(
        new DealerBranchFilter({ dealerGroupId: dealerGroupId, name: name }),
        0
      )
    ).map((x) => ({
      id: x.dealerBranchId,
      label: x.dealerBranchName,
      original: x,
    }));
  }
  render() {
    const { dealerGroupId, ...rest } = this.props;
    return (
      <AsyncDropdown
        placeholder="All"
        isClearable={true}
        fetchItems={(name) => this.fetchItems(name, dealerGroupId)}
        alwaysFetchItems={
          dealerGroupId && dealerGroupId !== null ? true : false
        }
        prepopulateFromStorage={true}
        {...rest}
      />
    );
  }
}
